export default __webpack_public_path__ + "static/media/authentication.16d6fb55.svg";